import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";
import {CompanyUserDetails} from "../types/CompanyUserDetails";

export const useUpdateCompanyUser = (
	details: CompanyUserDetails,
	onSuccess: (result: ApiResult) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("user/update", { details: details }) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError(`Error when updating user ${details.userName}: ` +
					result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
